import script from "./FillDemoAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./FillDemoAccount.vue?vue&type=script&setup=true&lang=js"

import "./FillDemoAccount.vue?vue&type=style&index=0&id=0fef03ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fef03ae"]])

export default __exports__